module.exports = __webpack_public_path__ + "assets/ParallelogramBy3Midpoints.315d21c166ff0d176f7ccfe199cb5b1b.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/ParallelogramBy3Midpoints.gmt
// module id = 979
// module chunks = 0